import { RuleCreatePageKey, RuleListPageKey } from '../../TModules';

export const translations = {
  [RuleListPageKey]: {
    SearchPlaceholder: 'Rechercher une règle par nom ou ID',
    ApproveRequests: 'Approuver les demandes',
    CreateRule: 'Créer une règle',
    Rules: 'Règles',
    RuleActivatedSuccessfully: 'Règle activée avec succès.',
    ActivationRequestSubmittedForApproval: "Demande d'activation soumise pour approbation.",
    RuleDeactivatedSuccessfully: 'Règle désactivée avec succès.',
    RuleDeactivationRequestSubmittedForApproval:
      'Demande de désactivation de règle soumise pour approbation.',
    MultipleApproveRequestSuccessMessage:
      "Demande d'approbation multiple soumise pour approbation.",
    ErrorApprovingRewards: "Erreur lors de l'approbation des récompenses.",
    ApproveMultipleRequests: 'Approuver plusieurs demandes ?',
    ApproveSelected: 'Approuver la sélection',
    ApproveMultipleRequestsMessageLineOne:
      'Êtes-vous sûr de vouloir approuver toutes les demandes sélectionnées ?',
    ApproveMultipleRequestsMessageLineTwo:
      "Veuillez vérifier les détails avant d'approuver car cette action ne peut pas être annulée.",
    ApproveRequestSuccessMessage: "Message de succès de la demande d'approbation.",
    SomethingWentWrong: "Une erreur s'est produite.",
    ApproveRuleTitle: 'Approuver la règle ?',
    SubmitDeletionRequestTitle: 'Soumettre une demande de suppression ?',
    Approve: 'Approuver',
    RequestDeletion: 'Demander la suppression',
    ApproveRuleMessageLineOne: 'Êtes-vous sûr de vouloir approuver cette règle ?',
    ApproveRuleMessageLineTwo: 'Cette action ne peut pas être annulée.',
    SubmitDeletionRequestMessageLineOne:
      "Cette règle est en attente d'approbation. Êtes-vous sûr de vouloir la supprimer ?",
    SubmitDeletionRequestMessageLineTwo:
      'Une fois la suppression approuvée, cette règle ne sera plus disponible et vous devrez la créer à nouveau.',
    Tabs: {
      All: 'Tout',
      Scheduled: 'Planifié',
      Active: 'Actif',
      Inactive: 'Inactif',
      Ended: 'Terminé',
      Pending: 'En attente'
    },
    Columns: {
      RuleName: 'Nom de la règle',
      Status: 'Statut',
      Comment: 'Commentaire',
      RequestType: 'Type de demande',
      Balance: 'Solde',
      StartDate: 'Date de début',
      EndDate: 'Date de fin',
      Trigger: 'Déclencheur',
      Outcome: 'Résultat',
      Actions: 'Actions',
      ID: 'ID',
      Rule: 'Règle',
      Multiple: 'Multiples'
    },
    Errors: {
      ErrorActivatingRule: "Erreur lors de l'activation de la règle",
      ErrorDeactivatingRule: 'Erreur lors de la désactivation de la règle'
    },
    Actions: {
      Show: 'Afficher',
      Approve: 'Approuver',
      Review: 'Examiner',
      Activate: 'Activer',
      Deactivate: 'Désactiver',
      Duplicate: 'Dupliquer',
      Edit: 'Modifier'
    },
    CampaignRuleModal: {
      Create: 'Créer une règle de campagne',
      Edit: 'Modifier la règle de campagne',
      OkText: 'Ajouter',
      UpdateText: 'Mettre à jour',
      RuleName: 'Nom de la règle',
      RuleType: 'Type de règle',
      RuleGetsTriggeredIf: 'La règle se déclenche si :',
      Priority: 'Priorité',
      RuleOutcome: 'Résultat de la règle',
      OutcomeType: 'Type de résultat',
      OutcomeValue: 'Valeur du résultat',
      OutcomeValuePlaceholder: 'Entrer la valeur du résultat'
    },
    RuleTriggerLimitSegment: {
      TriggerLimits: 'Limites de déclenchement',
      TotalNumberOfTriggerEvents:
        "Nombre total d'événements déclencheurs (au niveau de la campagne)",
      TriggerLimit: 'Limite de déclenchement',
      TriggerLimitPlaceholder: '∞',
      TotalNumberOfTriggerEventsPerUser: "Nombre total d'événements déclencheurs (par utilisateur)",
      TriggerRateLimitPerUser: 'Limite de fréquence de déclenchement (par utilisateur)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        'Laissez les champs de limite vides pour des événements déclencheurs illimités',
      Days: 'Jours',
      Weeks: 'Semaines',
      Months: 'Mois',
      Years: 'Années',
      TriggerEventsForEvery: 'événement(s) déclencheur(s)^ pour chaque'
    },
    TransactionalFields: {
      ChooseOne: 'Choisissez-en un...',
      SelectTrigger: 'Sélectionner un déclencheur',
      SelectOperator: 'Sélectionner un opérateur',
      AddCondition: 'Ajouter une condition',
      FromDate: 'Date de début',
      ToDate: 'Date de fin',
      And: 'Et'
    },
    PersonalPropertyFilterField: {
      WhereHeader: 'LORSQUE les mises à jour du profil incluent',
      InfoNote:
        'La règle ne sera déclenchée que si la mise à jour du profil modifie TOUTES les clés spécifiées avec les valeurs spécifiées.',
      Key: 'Clé',
      Value: 'Valeur',
      Operator: 'Opérateur',
      KeyPlaceholder: 'Clé',
      ValuePlaceholder: 'Valeur',
      SelectOperator: 'Sélectionner un opérateur',
      PleaseSeparateValuesUsingComma: 'Veuillez séparer les valeurs multiples par une virgule',
      AttributeLabel: 'Propriété personnelle',
      Equals: 'Égal à',
      NotEquals: 'Différent de',
      In: 'Dans',
      NotIn: 'Pas dans',
      Like: 'Contient',
      NotLike: 'Ne contient pas',
      KeyRequired: 'La clé de propriété est obligatoire',
      OperatorRequired: "L'opérateur est obligatoire",
      OperatorInvalid: "L'opérateur est obligatoire",
      ValueRequired: 'La valeur est obligatoire'
    },
    TransactionPropertyField: {
      PropertyDataType: 'Type de données de propriété',
      Key: 'Clé',
      Sunday: 'Dimanche',
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Value: 'Valeur',
      PleaseSeparateMultipleValuesUsingComma:
        'Veuillez séparer les valeurs multiples par des virgules',
      SelectOperator: 'Sélectionner un opérateur',
      Loading: 'Chargement...',
      TableName: 'Nom de la table',
      Type: 'Type',
      SampleValues: 'Exemples de valeurs',
      Operator: 'Opérateur'
    },
    AutomationFields: {
      SelectTrigger: 'Sélectionner un déclencheur',
      ChooseOne: 'Choisissez-en un...',
      OutcomeType: 'Type de résultat',
      SelectTriggerPlaceholder: 'Veuillez sélectionner un déclencheur'
    },
    MerchantRewardSelectField: {
      SelectMerchant: 'Sélectionner un marchand',
      Edit: 'Modifier',
      Add: 'Ajouter',
      Merchant: 'Marchand'
    },
    MerchantSelectModal: {
      Title: 'Sélectionner un marchand',
      AddMerchant: 'AJOUTER UN MARCHAND',
      Cancel: 'ANNULER',
      SearchPlaceholder: 'Rechercher un marchand par nom ou ID',
      Active: 'Actif',
      Inactive: 'Inactif',
      Name: 'Nom',
      Status: 'Statut',
      DateCreated: 'Date de création',
      ID: 'ID'
    },
    RewardSelectField: {
      SelectReward: 'Sélectionner une récompense',
      Edit: 'Modifier',
      Add: 'Ajouter',
      Reward: 'Récompense'
    },
    RewardSelectModal: {
      Title: 'Sélectionner une récompense',
      AddReward: 'Ajouter une récompense',
      Cancel: 'Annuler',
      SearchPlaceholder: 'Rechercher une récompense par nom, ID ou marchand',
      All: 'Tout',
      Active: 'Actif',
      Approved: 'Approuvé',
      Private: 'Privé',
      System: 'Système',
      Merchant: 'Marchand',
      Balance: 'Solde',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      Reward: 'Récompense',
      RewardName: 'Nom de la récompense',
      ID: 'ID'
    }
  },

  [RuleCreatePageKey]: {
    LoadingRule: 'Chargement de la règle',
    Steps: {
      SetupRule: 'Configurer la règle',
      SetupAudience: "Configurer l'audience",
      Review: 'Révision'
    },
    EditMessage: {
      MakerCheckerSuccess: 'Demande soumise pour approbation',
      Success: "Règle d'automatisation modifiée avec succès !",
      TransactionRulesError: 'Une erreur est survenue. Veuillez réessayer plus tard.',
      RuleRequestError: "Erreur lors de la configuration de l'automatisation",
      TransactionRulesSuccess: "Règle d'automatisation créée !",
      TransactionRulesMakerCheckerSuccess: 'Règle soumise pour approbation',
      TransactionRulesRequestError: "Erreur lors de la configuration de l'automatisation"
    },
    Cancel: 'Annuler',
    Back: 'Retour',
    SaveAsDraft: 'Enregistrer comme brouillon',
    Publish: 'Publier',
    Launch: 'Lancer',
    Next: 'Suivant',

    RuleSetup: {
      Essentials: 'Essentiels',
      Name: 'Nom',
      NamePlaceholder: 'Saisissez le nom de votre règle ici',
      Labels: 'Étiquettes',
      LabelsPlaceholder: 'Saisissez vos étiquettes ici',
      Partner: 'Partenaire',
      PartnerPlaceholder: 'Veuillez sélectionner votre partenaire',
      Owner: 'Propriétaire',
      OwnerPlaceholder: 'Veuillez sélectionner un propriétaire',
      Mechanics: 'Mécaniques',
      ValidityPeriod: 'Période de validité',
      TriggerLimits: 'Limites de déclenchement',
      TotalNumberofTriggerEvents:
        "Nombre total d'événements déclencheurs (au niveau de la campagne)",
      TotalNumberofTriggerEventsPerUser: "Nombre total d'événements déclencheurs (par utilisateur)",
      TriggerRateLimitPerUser: 'Limite de fréquence de déclenchement (par utilisateur)',
      TriggerRateLimitOnCampaignLevel:
        'Limite de fréquence de déclenchement (au niveau de la campagne)',
      Days: 'Jours',
      Weeks: 'Semaines',
      Months: 'Mois',
      Years: 'Années',
      LimitTo: 'Limiter à',
      TriggerEvent: 'événement(s) déclencheur(s)^ pour chaque',
      UnlimitedTriggerEvents:
        'Laissez le champ de limite vide pour des événements déclencheurs illimités',
      Startdate: 'Date de début',
      Enddate: 'Date de fin',
      NoEnddate: 'Pas de date de fin',
      SelectATrigger: 'Sélectionner un déclencheur :',
      SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
      SelectNextTier: 'Sélectionner le niveau suivant',
      SelectCampaign: 'Sélectionner une campagne',
      Custom: 'Personnalisé',
      Transaction: 'Transaction',
      Loyalty: 'Fidélité',
      Reward: 'Récompense',
      Milestone: 'Campagne',
      Customer: 'Client',
      Location: 'Localisation',
      SelectTrigger: 'Sélectionner un déclencheur',
      AgeingPointsHelp:
        "Le nombre de points sur le point d'expirer sera vérifié au début de chaque cycle de révision.",
      AchievedNextTier: 'Niveau suivant atteint',
      NearTier: '10% proche du niveau suivant',
      PointsIssued: 'Points émis',
      PointsEarnedorRedeemed: 'Points gagnés ou échangés',
      PointsEarnedOrRedeemed: 'Points gagnés ou échangés',
      SelectLoyaltyTransactionType: 'Sélectionner le type de transaction de fidélité',
      LoyaltyTransactionType: {
        earn: 'Gagner',
        burn: 'Utiliser'
      },
      LoyaltyConditions: {
        Attribute: {
          amount: 'Montant',
          transaction_properties: 'Possède la propriété'
        },
        Operator: {
          equals: 'est égal à',
          not_equals: "n'est pas égal à",
          greater_than: 'supérieur à',
          greater_than_or_equal_to: 'supérieur ou égal à',
          less_than: 'inférieur à',
          less_than_or_equal_to: 'inférieur ou égal à',
          in: 'dans',
          not_in: 'pas dans',
          contains: 'contient',
          not_contain: 'ne contient pas'
        }
      },
      AgeingPoints: "Points vieillissants (points sur le point d'expirer dans le cycle actuel)",
      RedeemReward: 'Échanger une récompense',
      IssueReward: 'Émettre une récompense',
      IssueRewardFromCampaign: 'Émettre une récompense depuis la campagne',
      IssueRewardFromMerchant: 'Émettre une récompense depuis le marchand',
      VoucherForParticularRewardExpiringIn: 'Bon pour une récompense particulière expirant dans',
      AnyVoucherExpiringIn: 'Tout bon expirant dans {days} jours',
      StampRedeemed: 'Tampon échangé',
      StampsIssued: 'Tampons émis',
      StampsInactive: 'Tampons inactifs',
      GamePlayed: 'Jeu joué',
      GameTryIssued: 'Essai de jeu émis',
      CampaignEnrolled: 'Inscrit à la campagne',
      CampaignCompleted: 'Campagne terminée',
      CampaignNotCompleted: 'Campagne non terminée',
      ProgressLevelAchieved: 'Niveau de progression atteint',
      ProgressRuleTriggered: 'Règle de progression déclenchée',
      QuestTaskCompleted: 'Tâche de quête terminée',
      SignUp: 'Inscription',
      SignIn: 'Connexion',
      ProfileUpdated: 'Profil mis à jour',
      LoyaltyProgramSelectPlaceholder: 'Sélectionner le programme de fidélité',
      SelectTriggerPlaceholder: 'Veuillez sélectionner un déclencheur'
    },

    MilestoneField: {
      SelectStampCampaign: 'Sélectionner une campagne de tampons',
      Change: 'Modifier',
      Select: 'Sélectionner',
      StampCampaign: 'Campagne de tampons',
      AnyRewardsSelected:
        'Toutes les récompenses {isCampaignRewardsSelected} dans cette campagne seront un déclencheur',
      SelectStampsSlot: "Sélectionner l'emplacement des tampons",
      SelectStampPosition: 'Sélectionner la position de la carte de tampons'
    },

    CampaignSelectField: {
      Interval: 'Intervalle',
      Days: '(Jours)',
      SelectStampCampaign: 'Sélectionner une campagne de tampons',
      Change: 'Modifier',
      Select: 'Sélectionner',
      StampCampaign: 'Campagne de tampons',
      SelectACampaign: 'Sélectionner une campagne',
      Edit: 'Modifier',
      Add: 'Ajouter',
      Campaign: 'Campagne',
      ID: 'ID',
      SelectAMilestone: 'Sélectionner une étape',
      SelectARule: 'Sélectionner une règle',
      SelectATask: 'Sélectionner une tâche'
    },

    GameSelectField: {
      SelectAGameCampaign: 'Sélectionner une campagne de jeu',
      Game: 'Jeu',
      Campaign: 'Campagne',
      Change: 'Modifier',
      Select: 'Sélectionner'
    },

    CampaignRewardSelectField: {
      SelectACampaign: 'Sélectionner une campagne',
      Change: 'Modifier',
      Select: 'Sélectionner',
      Campaign: 'Campagne',
      SelectAReward: 'Sélectionner une récompense (Optionnel)',
      Reward: 'Récompense',
      ID: 'ID'
    },

    MerchantRewardSelectField: {
      SelectAMerchant: 'Sélectionner un marchand',
      Change: 'Modifier',
      Select: 'Sélectionner',
      Merchant: 'Marchand',
      AddMerchant: 'Ajouter un marchand',
      Cancel: 'Annuler',
      SearchMerchant: 'Rechercher un marchand par nom ou ID',
      Active: 'Actif',
      Inactive: 'Inactif',
      ID: 'ID'
    },

    RewardSelectField: {
      SelectAReward: 'Sélectionner une récompense (Optionnel)',
      Change: 'Modifier',
      Reward: 'Récompense',
      Select: 'Sélectionner',
      WarningText:
        "Le type de résultat est limité à [Push Event] lorsqu'une récompense système est sélectionnée"
    },

    RewardExpirySetupField: {
      SelectAReward: 'Sélectionner une récompense',
      Change: 'Modifier',
      Select: 'Sélectionner',
      Reward: 'Récompense',
      Periods: 'Périodes (Jours)'
    },

    CheckInFields: {
      EnterLocationDetails: 'Saisir les détails de localisation',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      Radius: 'Rayon',
      DegreesLatitude: 'Degrés (-90.0 à 90.0)',
      DegreesLongitude: 'Degrés (-180.0 à 180.0)',
      PermissibleRadiusInMeter: 'Rayon autorisé (en mètres)',
      PermissibleRadius: 'Rayon autorisé',
      Preview: 'APERÇU'
    },

    OutcomeSection: {
      Outcome: 'Résultat :',
      MediaTagsToInclude: 'Tags médias à inclure',
      SelectMediaTags: 'Sélectionner les tags médias',
      SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
      SelectPointEarnType: 'Sélectionner le type de gain de points',
      FixedPoints: 'Points fixes',
      VariablePoints: 'Points variables',
      NumberOfPoints: 'Nombre de points',
      PointsSignHint:
        '(Saisissez un nombre positif pour ajouter des points et un nombre négatif pour en déduire.)',
      Award: 'Récompense',
      ForEvery: 'Pour chaque',
      UpToAMaximumOf: "Jusqu'à un maximum de",
      Currency: 'Devise',
      SelectGLAccount: 'Sélectionner le compte GL',
      GLAccountName: 'Nom du compte GL',
      GLAccountNamePlaceholder: 'nom du compte gl',
      Points: 'Points',
      GLAccountType: 'Type de compte GL',
      GLAccountTypePlaceholder: 'type de compte gl',
      EnterKeyName: 'Saisir le nom de la clé',
      KeyName: 'Nom de la clé',
      EnterValueDetails: 'Saisir les détails de la valeur',
      KeyValue: 'Valeur de la clé',
      AddMore: 'Ajouter Plus'
    },

    OutcomeList: {
      RemoveOutcome: 'Supprimer le résultat à la position {{position}}',
      MaxOutcomesReached: 'Une règle peut comporter au maximum 10 résultats.',
      AddOutcome: 'Ajouter un résultat',
      Position: 'Position {{position}}',
      Then: 'ENSUITE :',
      SequentialExecutionNotice: 'Les résultats sont exécutés séquentiellement',
      OutcomeIdMatchesType:
        'Ce résultat ne correspond pas au type sélectionné. Veuillez le sélectionner à nouveau.'
    },

    OutcomeTypeField: {
      SelectOutcomeType: 'Sélectionner le type de résultat',
      Campaign: 'Campagne',
      Rewards: 'Récompenses',
      Points: 'Points',
      Audience: 'Audience',
      UpdateCustomerDetails: 'Mettre à jour les détails client',
      PushEventOnly: 'Push Event uniquement',
      CustomFieldsTitle: 'Champs personnalisés',
      AddCustomField: '+ Ajouter un champ personnalisé',
      CustomFieldValidation: '{title} est requis.',

      CustomFields: {
        Key: 'Clé',
        Value: 'Valeur',
        CustomFieldsError: 'Veuillez sélectionner les champs personnalisés corrects !',
        UniqueKeyError: 'La clé doit être unique !'
      }
    },

    OutcomeCampaignSelectField: {
      SelectCampaignType: 'Sélectionner le type de campagne',
      Stamp: 'Tampon',
      Game: 'Jeu',
      Quiz: 'Quiz',
      Survey: 'Sondage',
      SelectCampaign: 'Sélectionner une campagne',
      Change: 'Modifier',
      Select: 'Sélectionner',
      Campaign: 'Campagne',
      BonusStamps: 'Tampons bonus',
      BonusTries: 'Essais bonus'
    },

    OutcomeRewardSelectField: {
      SelectReward: 'Sélectionner une récompense',
      Change: 'Modifier',
      Reward: 'Récompense',
      Select: 'Sélectionner',
      OnlySystemRewardsShown: 'Seules les récompenses système sont affichées.'
    },

    OutcomePointExpiry: {
      OutcomeExpiresAt: 'Le résultat expire le'
    },

    OutcomeAudienceField: {
      SelectAudienceList: "Sélectionner la liste d'audience",
      SelectAudienceListPlaceholder: "Sélectionner la liste d'audience"
    },

    LoyaltyAudience: {
      SelectAudience: 'Sélectionner une audience',
      DefaultAudience: 'Créer une audience à usage unique pour cette campagne',
      ExistingAudience: 'Sélectionner une audience existante',
      AudienceSetup: "Configuration de l'audience",
      SelectAudienceV4Placeholder: 'Sélectionner une audience',
      SelectFilters: 'Sélectionner les filtres',
      SelectedFilters: 'Filtres sélectionnés',
      NoFiltersSelected: 'Aucun filtre sélectionné',

      AudienceListSetup: {
        Include: 'Inclure',
        Exclude: 'Exclure',
        AudienceExistsMessage:
          'Impossible de {{audienceIncludeExclude}} une audience déjà définie pour {{audienceIncludeExcludeNoun}}',
        PickAudienceList: "Choisir une liste d'audience",

        Includes: 'Inclut',
        Excludes: 'Exclut',
        AudienceWarningMessage:
          "Le fichier d'audience téléchargé ne sera traité qu'après avoir été approuvé par un approbateur d'actions en masse",
        SelectedFileForInclusion: "Fichier sélectionné pour l'inclusion",
        AudienceNotInTheList: 'Audience non présente dans la liste',
        IncludeAudienceFilenamePlaceholder: "Nommer la liste d'audience incluse",
        UploadNow: 'Télécharger maintenant',
        UploadNewList: 'Télécharger une nouvelle liste',
        AcceptedFormat: 'Format accepté : fichiers .xlsx/.csv uniquement.',
        DownloadSample: 'Télécharger un exemple',
        UploadExclusion: "Télécharger l'exclusion",
        SelectedFileForExclusion: "Fichier sélectionné pour l'exclusion",
        ExcludeAudienceFilenamePlaceholder: "Nommer la liste d'audience exclue",

        SubmittingData: 'Soumission des données...',
        SomethingWentWrong: "Une erreur s'est produite.",
        AutoCreateCustomers: "Créer également les clients s'ils n'existent pas"
      },

      AudienceFilters: {
        Age: 'Âge',
        BirthMonth: 'Mois de naissance',
        Gender: 'Genre',
        Location: 'Localisation',
        Loyalty: 'Fidélité',
        Personal: 'Personnel',
        Custom: 'Personnalisé',
        EmailTags: 'Tags email',
        Ethnicity: 'Ethnicité',
        SelectCustomerAttributeFilters: "Sélectionner vos filtres d'attributs client :",
        NoFiltersSelected: 'Aucun filtre sélectionné',
        And: 'et',
        Badge: 'Badge',
        Campaign: 'Campagne',
        Leaderboard: 'Classement',
        LoyaltyPoints: 'Points de fidélité',
        LoyaltyTier: 'Niveau de fidélité',
        MemberSince: 'Membre depuis',
        Reward: 'Récompense',
        Filter: 'Basé sur le paiement',
        Payment: 'Paiement',
        SelectFilters: "Sélectionner les filtres pour générer automatiquement une liste d'audience",
        City: 'Ville',
        States: 'États',

        OfferId: "ID de l'offre",
        PrimaryClusterComb: 'Combinaison de cluster primaire',
        PrimaryClusterState: 'État du cluster primaire',
        Membership: 'Membre de',
        CurrentBirthday: 'Uniquement le jour de naissance',
        CurrentBirthMonth: 'Uniquement pendant le mois de naissance',
        HasBirthday: "Le jour de l'anniversaire",
        UserType: "Type d'utilisateur",
        AccountConfirmedAt: 'Inscrit entre',
        LoyaltyPointsBalance: 'Solde de points',
        CampaignEnrolment: 'Campagne',
        LeaderboardPosition: 'Position dans le classement',
        UPI: 'UPI',
        ScanPay: 'Scan pay',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Adresse actuelle',
        PaymentStatus: 'Statut de paiement',
        DaysPastDues: 'Jours de retard',
        BNPLUnpaidEMIDate: 'Date EMI impayée BNPL',
        InstaloanUnpaidEMIDate: 'Date EMI impayée Instaloan',

        AgeFilter: {
          Title: 'Âge',
          Includes: 'Inclut',
          Excludes: 'exclut',
          SelectPlaceholder: 'Inclut',
          From: 'âges de',
          FromPlaceholder: '18',
          To: 'à',
          ToPlaceholder: '35',
          AddRange: 'Ajouter une plage',
          And: 'et'
        },
        BirthdayFilter: {
          Title: 'Anniversaire',
          SelectBirthMonth: 'Sélectionner le mois de naissance',
          BirthMonth: 'Mois de naissance',
          CurrentBirthMonth: 'Mois de naissance actuel',
          OnlyDuringMonthOfBirth: 'Uniquement pendant le mois de naissance',
          HasBirthday: 'A son anniversaire',
          OnBirthday: "Le jour de l'anniversaire",
          Includes: 'Inclut',
          Excludes: 'Exclut'
        },
        GenderFilter: {
          Title: 'Genre',
          SelectByGender: 'Sélectionner par genre',
          Male: 'Homme',
          Female: 'Femme'
        },
        EthnicityFilter: {
          Title: 'Ethnicité',
          SelectEthnicity: "Sélectionner l'ethnicité",
          SelectEthnicityPlaceholder: "Sélectionner l'ethnicité",
          Include: 'Inclure',
          Exclude: 'Exclure',
          Includes: 'Inclut',
          Excludes: 'exclut'
        },
        LocationFilter: {
          Title: 'Localisation',
          SelectCity: 'Sélectionner la ville',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectCityPlaceholder: 'Sélectionner les villes',
          SelectState: "Sélectionner l'état",
          SelectStatePlaceholder: "Sélectionner l'état",
          Includes: 'Inclut',
          Excludes: 'Exclut'
        },

        PersonalFilter: {
          Title: 'Personnel',
          HubClub: 'Hub Club',
          Select: 'Sélectionner',
          Include: 'Inclure',
          Exclude: 'Exclure',
          AddCustomProperties: 'Ajouter des propriétés personnalisées',
          EnterKeyNameAndValueDetails: 'Saisir le nom de la clé et les détails de la valeur',
          SelectRelation: 'Sélectionner la relation',
          EnterNumber: 'Saisir un nombre',
          KeyValue: 'Valeur de la clé',
          DatePlaceholder: 'JJ-MM-AAAA',
          KeyNamePlaceholder: 'Nom de la clé',
          Is: 'Est',
          True: 'Vrai',
          False: 'Faux',
          And: 'ET',
          Or: 'OU',
          CustomAttributeType: 'Attribut personnalisé #{{index}} : type',
          CustomAttribute: 'Attribut personnalisé #{{index}} : attribut',
          CustomAttributeOperator: 'Attribut personnalisé #{{index}} : opérateur',
          CustomAttributeValue: 'Attribut personnalisé #{{index}} : valeur',
          Includes: 'inclut',
          Excludes: 'exclut'
        },

        LoyaltyFilter: {
          Title: 'Fidélité',
          SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectProgram: 'Sélectionner le programme',
          Includes: 'Inclut',
          Excludes: 'Exclut',
          UsersWhoAchieved: 'Utilisateurs ayant atteint',
          SelectProgramAndTier: 'Sélectionner le programme et le niveau',
          UsersWithPointsBalance: 'Utilisateurs avec un solde de points',
          SelectLoyaltyProgramPlaceholder: 'Sélectionner le programme de fidélité',
          From: 'De',
          To: 'À',
          PointsBalanceFrom: 'Solde de points de',
          PointsBalanceTo: 'Solde de points à'
        },

        EmailTagsFilter: {
          Includes: 'Inclut',
          SelectEmailTags: 'Sélectionner les tags email',
          Excludes: 'Exclut'
        },

        PaymentBasedFilter: {
          IncludeUsersWith: 'Inclure les utilisateurs avec',
          UPI: 'UPI',
          ScanPay: 'Scan pay',
          BBPS: 'BBPS',
          KYC: 'KYC',
          CurrentAddress: 'Adresse actuelle',
          PaymentStatus: 'Statut de paiement',
          DaysPastDues: 'Jours de retard',
          BNPLUnpaidEMIDate: 'Date EMI impayée BNPL',
          InstaloanUnpaidEMIDate: 'Date EMI impayée Instaloan',
          SelectFromList: 'Sélectionner dans la liste',
          SelectDate: 'Sélectionner la date',
          Upcoming: 'À venir',
          DueNow: 'Dû maintenant',
          Future: 'Futur',
          Overdue: 'En retard',
          None: 'Aucun',
          Includes: 'Inclut',
          Excludes: 'Exclut'
        }
      }
    },

    RuleDetail: {
      Title: 'Détail de la règle',
      RuleName: 'Nom de la règle',
      Status: 'Statut',
      StartTime: 'Heure de début',
      EndTime: 'Heure de fin',
      Labels: 'Étiquettes',
      Notification: 'Notification',
      Owner: 'Propriétaire',
      Partner: 'Partenaire',
      On: 'ACTIVÉ',
      Off: 'DÉSACTIVÉ',
      Merchant: 'Marchand',
      Trigger: 'Déclencheur',
      TriggerType: 'Type de déclencheur',
      TriggerEventName: "Nom de l'événement déclencheur",
      Conditions: 'Conditions',
      Campaign: 'Campagne',
      Reward: 'Récompense',
      Loyalty: 'Fidélité',
      Tier: 'Niveau',
      AutomationTrigger: "Déclencheur d'automatisation",
      TotalTriggerLimit: 'Limite totale de déclenchements',
      UserLifetimeLimit: 'Limite de durée de vie utilisateur',
      TriggerLimitPerUser: 'Limite de déclenchements (par utilisateur)',
      TriggerLimitOnCampaignLevel: 'Limite de déclenchements (au niveau de la campagne)',
      Outcome: 'Résultat',
      OutcomeType: 'Type de résultat',
      OutcomeProperties: 'Propriétés du résultat',
      OutcomePropertyKey: 'Clé',
      OutcomePropertyValue: 'Valeur',
      GLAccountNumber: 'Numéro de compte GL',
      GLAccountName: 'Nom du compte GL',
      CostCenterId: 'ID du centre de coût',
      BranchCode: "Code de l'agence",
      AudienceInfo: "Informations sur l'audience",
      TimesPerUser: 'Fois par',
      ID: 'ID'
    },

    CampaignDetail: {
      CampaignID: 'ID de campagne',
      CampaignName: 'Nom de la campagne',
      CampaignType: 'Type de campagne',
      BonusStamps: 'Tampons bonus',
      BonusTries: 'Essais bonus'
    },

    RewardDetail: {
      RewardID: 'ID de récompense',
      RewardName: 'Nom de la récompense'
    },

    LoyaltyDetail: {
      CampaignName: 'Nom de la campagne',
      Points: 'Points',
      OutcomeExpiresAt: 'Le résultat expire le',
      ForEvery: 'Pour chaque',
      UpToAMaximumOf: "Jusqu'à un maximum de"
    },

    LoyaltyTier: {
      NextTiers: 'Niveaux suivants',
      NextTier: 'Niveau suivant'
    },

    AutomationTrigger: {
      AutomationTrigger: "Déclencheur d'automatisation"
    },

    RuleRequestComment: {
      Content: 'Contenu',
      DeleteButton: 'Bouton supprimer',
      UserDescription: 'Description utilisateur',
      UserRole: 'Rôle utilisateur',
      Description: 'Description',
      Delete: 'Supprimer',
      Time: 'Heure',
      PendingRule: 'Règle en attente',
      Approve: 'Approuver',
      AddComment: 'Ajouter un commentaire',
      ViewAndAddComments: 'Voir et ajouter des commentaires',
      ApproveRule: 'Approuver la règle',
      PendingRuleDescription:
        "Cette règle est en attente d'approbation. Tous les commentaires ajoutés apparaîtront ici.",
      CommentsAdded: 'commentaires ajoutés'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Commentaire supprimé',
      ErrorMessage: 'Erreur lors de la suppression du commentaire',
      Title: 'Supprimer le commentaire ?',
      OkText: 'Supprimer',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir supprimer votre commentaire ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.',
      CancelText: 'Annuler'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approuver la campagne ?',
    ApproveDenyCampaignRequestModalButton: 'Approuver',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'La demande a été approuvée',
      ErrorMessage: "Une erreur s'est produite",

      ApproveTitle: 'Approuver la campagne ?',
      Title: 'Soumettre la demande de suppression ?',
      ApproveOkText: 'Approuver',
      OkText: 'Demander la suppression',
      CancelText: 'Annuler',

      ApproveDescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette campagne ?',
      ApproveDescriptionLineTwo: 'Cette action ne peut pas être annulée.',

      DescriptionLineOne:
        "Cette règle est en attente d'approbation. Êtes-vous sûr de vouloir la supprimer ?",
      DescriptionLineTwo:
        'Une fois la suppression approuvée, cette règle ne sera plus disponible et vous devrez la créer à nouveau.',
      ApproveRuleTitle: 'Approuver la règle ?',
      SubmitDeletionRequestTitle: 'Soumettre la demande de suppression ?',
      RequestDeletionOkText: 'Demander la suppression',
      ApproveRuleDescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette règle ?',
      ApproveRuleDescriptionLineTwo: 'Cette action ne peut pas être annulée.'
    },

    AddCommentModalTitle: 'Voir et ajouter des commentaires',
    AddCommentModalButton: 'Ajouter un commentaire',
    AddCommentModal: {
      SuccessMessage: 'Commentaire ajouté',
      ErrorMessage: "Erreur lors de l'ajout du commentaire",
      CancelText: 'Annuler',
      CommentInputPlaceholder: 'Saisissez votre commentaire ici',
      AddCommentButton: 'Ajouter un commentaire'
    },

    AudienceInfoTitle: "Informations sur l'audience",

    AudienceInfo: {
      Description: 'Audience sélectionnée :',
      NoListsSelected: 'Aucune liste sélectionnée',
      MakerCheckerSuccess: 'Request submitted for approval',
      Success: 'Automation Rule edited successfully!',
      TransactionRulesError: 'Something went wrong. Please try again later.',
      RuleRequestError: 'Error setting up automation',
      TransactionRulesSuccess: 'Automation Rule created!',
      TransactionRulesMakerCheckerSuccess: 'Rule submitted for approval',
      TransactionRulesRequestError: 'Error setting up automation'
    },

    AudienceInfoFilters: {
      Loyalty: 'Fidélité',
      Gender: 'Genre',
      Age: 'Âge',
      BirthMonth: 'Mois de naissance',
      Ethnicity: 'Ethnicité',
      City: 'Ville',
      States: 'États',
      OfferId: "ID de l'offre",
      PrimaryClusterComb: 'Combinaison de cluster primaire',
      PrimaryClusterState: 'État du cluster primaire',
      MemberOf: 'Membre de',
      OnlyDuringDayOfBirth: 'Uniquement pendant le jour de naissance',
      OnlyDuringMonthOfBirth: 'Uniquement pendant le mois de naissance',
      OnBirthday: "Le jour de l'anniversaire",
      UserType: "Type d'utilisateur",
      EmailTags: 'Tags email',
      SignedUpBetween: 'Inscrit entre',
      Reward: 'Récompense',
      Badge: 'Badge',
      PointsBalance: 'Solde de points',
      Campaign: 'Campagne',
      LeaderboardPosition: 'Position dans le classement',
      Upi: 'UPI',
      ScanPay: 'Scan pay',
      Bbps: 'BBPS',
      Kyc: 'KYC',
      CurrentAddress: 'Adresse actuelle',
      PaymentStatus: 'Statut de paiement',
      DaysPastDues: 'Jours de retard',
      BnplUnpaidEmiDate: 'Date EMI impayée BNPL',
      InstaloanUnpaidEmiDate: 'Date EMI impayée Instaloan'
    }
  }
};
